import { render } from "./v-wait.vue?vue&type=template&id=445a0563"
import script from "./v-wait.vue?vue&type=script&lang=js"
export * from "./v-wait.vue?vue&type=script&lang=js"

import exportComponent from "../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__